import React, { useEffect, useState } from "react";
import { Link, } from "react-router-dom";

import FeatherIcon from "feather-icons-react";
import Scrollbars from "react-custom-scrollbars-2";
import { history } from "../../_components/_helpers/history";
import { hooks } from "../../studentportal-sdk";
import $ from "jquery";
// import { LogoImg, LogoSmallImg } from "../_components/imagepath";
/* eslint-disable */

const Sidebar = (props) => {
  const [isSideMenu, setSideMenu] = useState("");
  const [isSideMenuLevel, setSideMenuLevel] = useState("");
  const [isSideMenuLevel2, setSideMenuLevel2] = useState("");

  const toggleSidebar = (value) => {
    setSideMenu(value);
  };
  const toggleSidebar1 = (value) => {
    setSideMenuLevel(value);
  };
  const toggleSidebar2 = (value) => {
    setSideMenuLevel2(value);
  };

  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }

    document.addEventListener("mouseover", handleMouseOver);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  useEffect(() => {
    $(document).on("change", ".sidebar-type-four input", function () {
      if ($(this).is(":checked")) {
        $(".sidebar").addClass("sidebar-eight");
        $(".sidebar-menu").addClass("sidebar-menu-eight");
        $(".menu-title").addClass("menu-title-eight");
        $(".header").addClass("header-eight");
        $(".header-left-two").addClass("header-left-eight");
        $(".user-menu").addClass("user-menu-eight");
        $(".dropdown-toggle").addClass("dropdown-toggle-eight");
        $(".white-logo").addClass("show-logo");
        $(
          ".header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)"
        ).addClass("hide-logo");
        $(".header-two .header-left-two .logo:not(.logo-small)").removeClass(
          "hide-logo"
        );
        $(".header-two .header-left-two .dark-logo").removeClass("show-logo");
      } else {
        $(".sidebar").removeClass("sidebar-eight");
        $(".sidebar-menu").removeClass("sidebar-menu-eight");
        $(".menu-title").removeClass("menu-title-eight");
        $(".header").removeClass("header-eight");
        $(".header-left-two").removeClass("header-left-eight");
        $(".user-menu").removeClass("user-menu-eight");
        $(".dropdown-toggle").removeClass("dropdown-toggle-eight");
        $(".white-logo").removeClass("show-logo");
        $(
          ".header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)"
        ).removeClass("hide-logo");
      }
    });
  }, []);
  const {
    authService: {
      store: { role },
      action: { userLogout },
    },
  } = props;

  let pathName = history.location.pathname;

  // const history = useHistory();

  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              
              <ul>
                <li className="menu-title">
                  <span>Main Menu</span>
                </li>
                <li
                  className={`${
                    "/admindashboard" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "index" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(isSideMenu == "index" ? "" : "index")
                    }
                  >
                    <FeatherIcon icon="grid" /> <span>Dashboard</span>{" "}
                    <span className="menu-arrow"></span>
                  </Link>
                  {isSideMenu == "index" ? (
                    <ul
                      style={{
                        display: isSideMenu == "index" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/admindashboard"
                          className={`${
                            "/admindashboard" === pathName ? "active" : ""
                          }`}
                        >
                          Dashboard
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
              {/* Management */}
              <ul>
                <li className="menu-title">
                  <span>Management</span>
                </li>
                <li
                  className={`${
                    "/users" === pathName ||
                    // "/usersview" === pathName ||
                    "/adduser" === pathName ||
                    "/addadmin" === pathName ||
                    "/edituser" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "Admin" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(isSideMenu == "Admin" ? "" : "Admin")
                    }
                  >
                    <i className="fas fa-users" /> <span> Admin</span>{" "}
                    <span className="menu-arrow" />
                  </Link>
                  {isSideMenu == "Admin" ? (
                    <ul
                      style={{
                        display: isSideMenu == "Admin" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/userlist"
                          className={`${"/users" === pathName ? "active" : ""}`}
                        >
                          Users List
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/addadmin"
                          className={`${"/addadmin" === pathName ? "active" : ""}`}
                        >
                         Add Admin
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to="/viewusers"
                          className={`${
                            "/studentsview" === pathName ? "active" : ""
                          }`}
                        >
                          View Users
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          to="/adduser"
                          className={`${
                            "/adduser" === pathName ? "active" : ""
                          }`}
                        >
                          Add User
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          to="/edituser"
                          className={`${
                            "/edituser" === pathName ? "active" : ""
                          }`}
                        >
                          Edit User
                        </Link>
                      </li> */}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                {/*            STUDENTS */}
                <li
                  className={`${
                    "/students" === pathName ||
                    "/studentsview" === pathName ||
                    "/addstudent" === pathName ||
                    "/editstudent" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "Students" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(isSideMenu == "Students" ? "" : "Students")
                    }
                  >
                    <i className="fas fa-graduation-cap" />{" "}
                    <span> Students</span> <span className="menu-arrow" />
                  </Link>
                  {isSideMenu == "Students" ? (
                    <ul
                      style={{
                        display: isSideMenu == "Students" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/students"
                          className={`${
                            "/students" === pathName ? "active" : ""
                          }`}
                        >
                          Student List
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to="/studentsview"
                          className={`${
                            "/studentsview" === pathName ? "active" : ""
                          }`}
                        >
                          Student View
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          to="/addstudent"
                          className={`${
                            "/addstudent" === pathName ? "active" : ""
                          }`}
                        >
                          Student Add
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to="/editstudent"
                          className={`${
                            "/editstudent" === pathName ? "active" : ""
                          }`}
                        >
                          Student Edit
                        </Link>
                      </li> */}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                {/*            Managers */}
                <li
                  className={`${
                    "/courses" === pathName ||
                    "/addcourse" === pathName ||
                    "/editcourse" === pathName ||
                    "/pendingcourse" === pathName ||
                    "/coursedetails" === pathName ||
                    "/profile" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "Blogs" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(isSideMenu == "Blogs" ? "" : "Blogs")
                    }
                  >
                    <i className="fa fa-book-reader" /> <span> Courses</span>
                    <span className="menu-arrow" />
                  </Link>
                  {isSideMenu == "Blogs" ? (
                    <ul
                      style={{
                        display: isSideMenu == "Blogs" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/courses"
                          className={`${"/blog" === pathName ? "active" : ""}`}
                        >
                          All Courses
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/addcourse"
                          className={`${
                            "/addblog" === pathName ? "active" : ""
                          }`}
                        >
                          Add Course
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/editcourse"
                          className={`${
                            "/editblog" === pathName ? "active" : ""
                          }`}
                        >
                          Edit Course
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                <li>
                  <Link to="/livesession">
                    <i className="fas fa-video" />
                    <span>Live Class</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/assessments">
                    <i className="fas fa-video" />
                    <span>Assessments</span>
                  </Link>
                </li> */}
                <li
                  className={`${
                    "/assessments" === pathName ||
                    "/viewassessment" === pathName ||
                    "/addassessment" === pathName ||
                    "/editassessment" === pathName ||
                    "/addassessmentquestions" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "Assessments" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(
                        isSideMenu == "Assessments" ? "" : "Assessments"
                      )
                    }
                  >
                    <i className="fas fa-graduation-cap" />{" "}
                    <span> Assessments</span> <span className="menu-arrow" />
                  </Link>
                  {isSideMenu == "Assessments" ? (
                    <ul
                      style={{
                        display: isSideMenu == "Assessments" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/assessments"
                          className={`${
                            "/assessments" === pathName ? "active" : ""
                          }`}
                        >
                          Assessment List
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/viewassessment"
                          className={`${
                            "/viewassessment" === pathName ? "active" : ""
                          }`}
                        >
                          View Assessments
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/addassessment"
                          className={`${
                            "/addassessment" === pathName ? "active" : ""
                          }`}
                        >
                          Add Assessment
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/addassessmentquestions"
                          className={`${
                            "/addassessmentquestions" === pathName
                              ? "active"
                              : ""
                          }`}
                        >
                          Add Assessment Questions
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/editassessment"
                          className={`${
                            "/editassessment" === pathName ? "active" : ""
                          }`}
                        >
                          Edit Assessment
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                <li className={`${"/profile" === pathName ? "active" : ""}`}>
                  <Link to="/profile">
                    <i className="fas fa-user" /> <span>Profile</span>
                  </Link>
                </li>

                <li
                  className={`${
                    "/event" === pathName || "/event" === pathName
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="/event">
                    <i className="fas fa-calendar-day" /> <span>Calendar</span>
                  </Link>
                </li>
                <li
                  className={`${
                    "/login" === pathName || "/othersettings" === pathName
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="#" onClick={() => userLogout()}>
                    <i className="fas fa-sign-out" /> <span>Logout</span>
                  </Link>
                </li>
              </ul>
              {/* /Management */}
              {/* Pages */}
              {/* <ul>
                <li className="menu-title">
                  <span>Pages</span>
                </li>
                <li
                  className={`${
                    "/login" === pathName ||
                    "/register" === pathName ||
                    "/forgotpassword" === pathName ||
                    "/error404" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "Authentication" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(
                        isSideMenu == "Authentication" ? "" : "Authentication"
                      )
                    }
                  >
                    <i className="fas fa-shield-alt" />{" "}
                    <span> Authentication </span>{" "}
                    <span className="menu-arrow" />
                  </Link>
                  {isSideMenu == "Authentication" ? (
                    <ul
                      style={{
                        display:
                          isSideMenu == "Authentication" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/login"
                          className={`${"/login" === pathName ? "active" : ""}`}
                        >
                          Login
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/register"
                          className={`${
                            "/register" === pathName ? "active" : ""
                          }`}
                        >
                          Register
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/forgotpassword"
                          className={`${
                            "/forgotpassword" === pathName ? "active" : ""
                          }`}
                        >
                          Forgot Password
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/error404"
                          className={`${
                            "/error404" === pathName ? "active" : ""
                          }`}
                        >
                          Error Page
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                <li className={`${"/blankpage" === pathName ? "active" : ""}`}>
                  <Link to="/blankpage">
                    <i className="fas fa-file" /> <span>Blank Page</span>
                  </Link>
                </li>
              </ul> */}
              {/* /Pages */}

              {/* UI Interface */}

              {/* /UI Interface */}
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
export default (props) => <Sidebar {...hooks.authentication(props)} />;
